export enum WebSocketEvent {
  ProcessingFinished = 'processing_finished',
}

export type Data = {
  channel: string;
  resource_type: string;
  resource_id: number | string;
};

export interface WebSocketError {
  error: string;
  status: number;
  message: string;
}

export type WebSocketSuccess = {
  event: WebSocketEvent;
};

export type WebSocketReceived = WebSocketSuccess | WebSocketError;

export type Callbacks = {
  received: (data: WebSocketReceived) => void;
  rejected?: () => void;
  onError?: (data: WebSocketError) => void;
};

export interface ChannelsContextType {
  subscribe: (data: Data, callbacks: Callbacks) => void;
  unsubscribe: () => void;
  disconnect: () => void;
}
